export default __webpack_public_path__ + "static/media/defaultFile.31d6cfe0.jfif";